export default class SpecType {
    constructor(spec, x, y) {
        this.label = this._getLabel(spec, x, y);
        this.value = this._getValue(spec, x, y);
    }

    _getLabel(spec, x, y) {
        if(spec === 'CIRCULAR') {
            return `直径 ${x} mm`;
        }
        return `${x} * ${y} mm`;
    }

    _getValue(spec, x, y) {
        if(spec === 'CIRCULAR') {
            return `${spec}_${x}`;
        }
        return `${spec}_${x}_${y}`;
    }
}